export default __webpack_public_path__ + "static/media/oran.14463ef4.png";